<template>
    <div class="modal modal-open" id="modal-add-skill">
        <div class="modal-overflow">
            <div class="modal-window" style="overflow-y: initial">
                <button class="btn btn-modal-close" @click="handleClose">
                    <i class="icon icon-cancel"></i>
                </button>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--tree">
                                <label for="name"
                                    >Expertise
                                    <span style="color: red">*</span></label
                                >
                                <treeselect
                                    v-model="new_data.skill_id"
                                    :multiple="false"
                                    :options="options"
                                    @input="onChangeSkillItem"
                                    @deselect="onChangeSkillItem"
                                    @select="onChangeSkillItem"
                                    :clearOnSelect="true"
                                />
                                <span class="error" v-if="error">Required</span>
                            </div>
                        </div>
                        <!-- <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--text">
                                <label for="name">Hourly rate</label>
                                <input
                                    type="text"
                                    v-model="new_data.hourly_rate"
                                    id="hourly_rate"
                                />
                            </div>
                        </div> -->
                        <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--text">
                                <label for="name">Cases url</label>
                                <input
                                    type="text"
                                    v-model="new_data.cases_url"
                                    id="cases_url"
                                />
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12">
                            <div class="btn-wrap jus-c--center">
                                <button
                                    @click="handleAdd"
                                    type="button"
                                    class="btn"
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
    name: "addSkill",
    props: {
        onClose: {
            type: Function,
            required: true,
        },
        onAdd: {
            type: Function,
            required: true,
        },

        isEdit: {
            type: Number,
            required: false,
        },
        editData: {
            type: Object,
            required: false,
        },
        onEdit: {
            type: Function,
            required: false,
        },
    },
    components: {
        Treeselect,
    },
    data() {
        return {
            // define the default value
            // define options
            options: [],
            new_data: {
                skill_id: null,
                cases_url: "",
                hourly_rate: "",
            },
            error: false,
        };
    },

    async mounted() {
        this.getSkills();
    },

    methods: {
        handleClose(e) {
            this.onClose(e);
        },

        getSkills() {
            axios
                .get("/agencies/business/getSkills")
                .then((r) => {
                    this.options = r.data;
                })
                .finally((r) => {
                    if (this.isEdit) {
                        this.new_data = JSON.parse(
                            JSON.stringify(this.editData)
                        );
                    }
                });
        },

        handleAdd(e) {
            this.error = false;
            if (!this.new_data.skill_id) {
                this.error = true;
                return;
            }

            if (this.isEdit) {
                this.onEdit(this.isEdit, this.new_data);
                return;
            }
            this.onAdd({
                cases_url: this.new_data.cases_url,
                hourly_rate: this.new_data.hourly_rate,
                skill_id: this.new_data.skill_id,
            });
        },

        onChangeSkillItem() {
            this.error = false;
            setTimeout(() => {
                if (!this.new_data.skill_id) {
                    this.error = true;
                    return;
                }
            }, 250);
        },
    },
};
</script>
